import React, { Component } from 'react';
import './styles.css';
import PropTypes from 'prop-types';
import { MultiYearScalarType } from '../../types';
import BusinessPlanSubSectionTitle from '../BusinessPlanSubSectionTitle';
import ProcurementSupplierLayout from '../ProcurementSupplierLayout';
import BottleSelector from '../BottleSelector';
import AppleSelector from '../AppleSelector';

class ProcurementSupplier extends Component {
	render() {
		const { game } = this.props;
		const { viewMode } = game;
		const {
			supplierBottleChoice,
			supplierAppleChoice,
			MinimumLotApples,
			CostApples,
			daysInPayablesApples
		} = game.procurement;

		return (
			<div className="procurement-supplier">
				<ProcurementSupplierLayout>
					<BusinessPlanSubSectionTitle
						label={'procurement-supplier-bottle-title'}
					/>
					<BottleSelector active={!viewMode} variable={supplierBottleChoice} />
					<BusinessPlanSubSectionTitle
						label={'procurement-supplier-apple-title'}
					/>
					<AppleSelector
						active={!viewMode}
						variable={supplierAppleChoice}
						MinimumSize={MinimumLotApples}
						Price={CostApples}
						DaysPayables={daysInPayablesApples}
					/>
				</ProcurementSupplierLayout>
			</div>
		);
	}
}

ProcurementSupplier.propTypes = {
	game: PropTypes.shape({
		id: PropTypes.string.isRequired,
		viewMode: PropTypes.bool,
		procurement: PropTypes.shape({
			supplierBottleChoice: PropTypes.object,
			supplierAppleChoice: PropTypes.object,
			MinimumLotApples: MultiYearScalarType,
			CostApples: MultiYearScalarType,
			daysInPayablesApples: MultiYearScalarType
		})
	})
};

export default ProcurementSupplier;
